import { DASHBOARD_CONFERENCE_HISTORY_API } from '../constants/routes';
import AuthService from './authservices';
import {
  ConferenceAffiliationWriteBody,
  ConferenceHistoryErrorResponse,
  ConferenceHistoryMutationResponse,
  ConferenceHistoryRequest,
  ConferenceHistoryResponse,
} from '../types/conferenceHistory';

const authService = new AuthService();

function conferenceHistoryUrl(username: string, selectedSport: string): URL {
  const requestUrl = new URL(DASHBOARD_CONFERENCE_HISTORY_API);
  requestUrl.searchParams.set('username', username);
  requestUrl.searchParams.set('selectedSport', selectedSport);
  return requestUrl;
}

export const fetchConferenceHistory = async ({
  username,
  selectedSport,
}: ConferenceHistoryRequest): Promise<ConferenceHistoryResponse> => {
  const response = await authService.authenticatedFetch(
    conferenceHistoryUrl(username, selectedSport).toString(),
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch conference history');
  }

  return response.json();
};

export const createConferenceAffiliation = async (
  { username, selectedSport }: ConferenceHistoryRequest,
  body: ConferenceAffiliationWriteBody
): Promise<ConferenceHistoryMutationResponse | ConferenceHistoryErrorResponse> => {
  const response = await authService.authenticatedFetch(
    conferenceHistoryUrl(username, selectedSport).toString(),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }
  );

  const payload = await response.json();
  if (!response.ok) {
    return payload as ConferenceHistoryErrorResponse;
  }
  return payload as ConferenceHistoryMutationResponse;
};

export const updateConferenceAffiliation = async (
  { username, selectedSport }: ConferenceHistoryRequest,
  affiliationId: number,
  body: ConferenceAffiliationWriteBody
): Promise<ConferenceHistoryMutationResponse | ConferenceHistoryErrorResponse> => {
  const url = conferenceHistoryUrl(username, selectedSport);
  url.pathname = `${url.pathname}/${affiliationId}`;

  const response = await authService.authenticatedFetch(url.toString(), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const payload = await response.json();
  if (!response.ok) {
    return payload as ConferenceHistoryErrorResponse;
  }
  return payload as ConferenceHistoryMutationResponse;
};

export function isConferenceHistoryError(
  result: ConferenceHistoryMutationResponse | ConferenceHistoryErrorResponse
): result is ConferenceHistoryErrorResponse {
  return result.success === false;
}
